<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Region</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="region.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="region.code" />
                                    <validation-error :errors="apiValidationErrors.code"  />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Zone
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="region.zone_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="Zones"
                                        placeholder="Select Zone"
                                        :options="available_zones_dropdown"
                                        :allow-empty="false">
                                </select-input>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Region</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '../../../components/Inputs/SelectInput';

export default {
    components: { ValidationError, SelectInput },

    mixins: [formMixin],

    data () {
        return  {
            region: {
                type:'regions',
                name:null,
                code:null,
                zone_id: null,
            },
            available_zones_dropdown: [],
        };
    },
    created ()  {
        this.getZoneDropDowns();
        this.get();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('regions/get', id);
                this.region = this.$store.getters['regions/region'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('regions/update', this.region);
                await this.$store.dispatch(
                    'alerts/success',
                    'Region updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        async getZoneDropDowns () {
            await this.$store.dispatch('zones/list');
            this.available_zones_dropdown =  await this.$store.getters['zones/list'];
        },
        goBack () {
            this.$router.push({ name: 'Regions List' });
        },
    },
};
</script>
